/**
 * Re-send killed drops — the endpoint and its result.
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';
import { unwrapApiData } from '@/hooks/smswiser-campaign-workspace/utils';

export type ResendOutcome =
  | {
      sourceId: string;
      status: 'sent';
      newId: string;
      dropId: number;
      uniqueId: string;
      title: string;
      executeAfter: string | null;
      workDate: string;
    }
  | { sourceId: string; status: 'skipped'; reason: string; message: string }
  | { sourceId: string; status: 'error'; ambiguous: boolean; message: string };

export interface ResendKilledResult {
  results: ResendOutcome[];
  sent: number;
  skipped: number;
  failed: number;
}

export interface ResendKilledBody {
  items: Array<{ id: string; executeAfter?: string }>;
  undoGroupId?: string;
}

export async function postResendKilled(
  countryKey: string,
  wiserId: number,
  body: ResendKilledBody,
): Promise<ResendKilledResult> {
  const res = await api.post(
    `/smswiser/campaigns/${encodeURIComponent(countryKey)}/${wiserId}/prepared-drops/resend-killed`,
    body,
  );
  return unwrapApiData<ResendKilledResult>(res.data);
}

export const EMPTY_RESEND_RESULT: ResendKilledResult = { results: [], sent: 0, skipped: 0, failed: 0 };

export function mergeResendResults(a: ResendKilledResult, b: ResendKilledResult): ResendKilledResult {
  return {
    results: [...a.results, ...b.results],
    sent: a.sent + b.sent,
    skipped: a.skipped + b.skipped,
    failed: a.failed + b.failed,
  };
}
